import React from 'react';
import { observer } from 'mobx-react';
import PromptItem from '../PromptItem';
import InfiniteScrollZone from '../../../../components/InfiniteScrollZone';
import ContentLoading from '../../../../components/ContentLoading';
import 'style.sass';
export default observer(function (_ref) {
  var store = _ref.store,
    prompts = _ref.prompts,
    view = _ref.view,
    scrollProvider = _ref.scrollProvider;
  return /*#__PURE__*/React.createElement("div", {
    className: "job-prompts"
  }, prompts.map(function (prompt) {
    return /*#__PURE__*/React.createElement(PromptItem, {
      prompt: prompt,
      store: store,
      view: view,
      key: prompt.id
    });
  }), /*#__PURE__*/React.createElement(InfiniteScrollZone, {
    scrollProvider: scrollProvider
  }, function (_ref2) {
    var isDone = _ref2.isDone;
    return !isDone && /*#__PURE__*/React.createElement(ContentLoading, {
      small: true
    });
  }));
});
//# sourceMappingURL=index.js.map
